import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import debounce from 'lodash.debounce';
import { GoogleApiWrapper } from 'google-maps-react';
import SoldOutModal from "./soldOut";
import { notification } from "antd";

import "../../../assets/css/eventPageStyle.css";
import supportEmailLogo from "../../../assets/imgs/SupportEmail.svg";
import supportPhoneLogo from "../../../assets/imgs/SupportPhone.svg";
import backArrow from "../../../assets/imgs/backArrowBlack.svg";
import info from "../../../assets/imgs/info.svg";
import sorry from "../../../assets/imgs/sorry.svg";
import redInfo from "../../../assets/imgs/RedInfo.svg";
import AddProducts from "./addProducts";
import ProductReview from "./productReview";
import { createEventPageOrder } from "../../../api";
import { AmountDivideByHundred } from "../../../helper";




const Products = (props) => {

    const { eventDetails, close, setPath, getOperatingTime, expiredToken, selectedDate, setSelectedDate } = props;
    const [mobileView, setMobileView] = useState(false);
    const [payload, setPayload] = useState({});
    const [isExpanded, setIsExpanded] = useState(false);
    const [current, setCurrent] = useState(0);
    const [matchedProduct, setMatchedProduct] = useState({});
    const [payLoading, setPayLoading] = useState(false);
    const [payNow, setPayNow] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [steps, setSteps] = useState([]);
    const [showButton, setShowButton] = useState(true);
    const [fullScreen, setFullScreen] = useState(false);
    const [showWarning, setShowWarning] = useState(false);
    const containerRef = useRef(null);
    const lastErrorRef = useRef({ message: "", timestamp: 0 });
    const paymentLockRef = useRef(false);
    const [isWrapped, setIsWrapped] = useState(false);

    const [orderItems, setOrderItems] = useState(() => {
        const storedItems = sessionStorage.getItem('placedItems-' + eventDetails.gid.replace('eventpage-', ''));
        return storedItems ? JSON.parse(storedItems) : [];
    });
    const [stockItems, setStockItems] = useState([]);
    const [count, setCount] = useState(0);
    const [timer, setTimer] = useState(true);
    const [expiryTime, setExpiryTime] = useState(() => {
        const storedTime = sessionStorage.getItem("expiryTime");
        return storedTime ? new Date(parseInt(storedTime, 10)) : null;
    });

    useEffect(() => {
        const handleResize = () => {
            setMobileView(window.innerWidth < 768);
        };
        handleResize();
        window.addEventListener('resize', handleResize);

        if (expiryTime) {
            showWarningToUser();
        }

        return () => window.removeEventListener('resize', handleResize);
    }, [expiryTime]);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        let secs = seconds % 60;
        if (secs < 10) {
            secs = `0${secs}`;
        }
        return showWarning ? `${minutes}m ${secs}s` : `${minutes}:${secs}`;
    };

    const getTimerColor = () => {
        if (count > 360) return "#2db300"; // First 9 mins (Green)
        if (count > 180) return "#e67300"; // Next 3 mins (Orange)
        return "#cc0000"; // Last 2 mins (Red)
    };

    useEffect(() => {
        if (expiryTime) {
            const interval = setInterval(() => {
                setCount(prevCount => {
                    const timeLeft = Math.trunc((expiryTime.getTime() - new Date().getTime()) / 1000);
                    if (timeLeft <= 0) {
                        expiredToken();
                        clearInterval(interval);
                        setTimer(true);
                        setCurrent(1);
                        return 0;
                    }
                    return timeLeft;
                });
            }, 1000);

            return () => clearInterval(interval);
        } else {
            if (eventDetails?.isSeatedEvent && timer) {
                const seconds = 600;
                const now = new Date();
                const newExpiryTime = new Date(now.getTime() + seconds * 1000);
                setExpiryTime(newExpiryTime);
                sessionStorage.setItem("expiryTime", newExpiryTime.getTime().toString());
                setCount(seconds);
                setTimer(false);
                showWarningToUser();
            }
        }
    }, [expiryTime, expiredToken, eventDetails, timer]);

    const notify = useMemo(
        () => debounce((msg) => {
            if (!msg) return;
            console.log("Showing Error Toast in Products:", msg);
            notification.destroy('event-error-toast'); // Close existing one to ensure it pops up again
            notification.error({
                key: 'event-error-toast', // Fixed key prevents multiple toasts from stacking
                message: "Notification",
                description: msg,
                duration: 4,
                placement: "topRight"
            });
        }, 500, { leading: true, trailing: false }),
        []
    );

    const productEntry = useCallback((product, index) => {
        setOrderItems(prev => [
            ...prev,
            {
                index,
                productGid: product.gid,
                name: product.eventPageProductName,
                title: product.eventPageProductType === 'TICKET'
                    ? 'Ticket' : product.eventPageProductType === 'FOOD'
                        ? 'Food' : product.eventPageProductName,
                lineItems: [],
                totalAmount: 0,
                totalCount: 0,
            }
        ]);
    }, []);


    const stockEntry = useCallback((product) => {
        let enabledStockItems = product.items.filter((item) => item.enableStock);

        const customEnabledItems = product.customItems?.flatMap((customItem) =>
            customItem.items?.filter((item) => item.enableStock) || []
        ) || [];

        setStockItems((prevStockItems) => {
            const updatedStockItems = [...prevStockItems, ...enabledStockItems, ...customEnabledItems].reduce(
                (unique, item) => {
                    if (!unique.some((existingItem) => existingItem.gid === item.gid)) {
                        unique.push(item);
                    }
                    return unique;
                },
                []
            );
            return updatedStockItems;
        });
    }, []);

    const showWarningToUser = () => {
        setShowWarning(true);
        const timer = setTimeout(() => setShowWarning(false), 5000);
        return () => clearTimeout(timer);
    };

    useEffect(() => {
        if (eventDetails?.eventPageProducts) {
            const newSteps = [];
            let index = 0;

            const isSeated = eventDetails?.isSeatedEvent;

            const ticketProduct = eventDetails.eventPageProducts.find(
                (product) => product.eventPageProductType === 'TICKET'
            );
            if (ticketProduct) {
                if (isSeated) {
                    newSteps.push({ title: 'Tickets', productGid: ticketProduct.gid });
                    const ticketIndex = orderItems.findIndex((update) => update.productGid === ticketProduct.gid);
                    if (ticketIndex === -1) {
                        productEntry(ticketProduct, index);
                    }
                    stockEntry(ticketProduct);
                    index = index + 1;
                } else {
                    // For non-seated events, just ensure it's in orderItems if needed, 
                    // though ProductReview handles it too. Let's keep it for consistency.
                    const ticketIndex = orderItems.findIndex((update) => update.productGid === ticketProduct.gid);
                    if (ticketIndex === -1) {
                        productEntry(ticketProduct, 0);
                    }
                    stockEntry(ticketProduct);
                }
            }

            // Food and Custom products currently don't have separate AddProducts UI
            // So we only add them as separate steps if the design requires it.
            // For now, let's keep them ONLY in ProductReview for non-seated events.
            // If they WERE meant to be separate steps, we'd add them here if isSeated is true?
            // Actually, AddProducts only handles ChooseSeats.
            // So only TICKET with isSeated makes sense for AddProducts.

            newSteps.push({ index, title: 'Review & Proceed', productGid: '' });

            setSteps(newSteps);
            setMatchedProduct(
                eventDetails.eventPageProducts.find((product) => product.gid === newSteps[0]?.productGid)
            );
        }
    }, [eventDetails, orderItems, productEntry, stockEntry]);

    const createOrderAndPay = useCallback(async (payload) => {
        if (paymentLockRef.current || payLoading) {
            console.log("Create order already in progress, ignoring duplicate call (Products)");
            return;
        }
        paymentLockRef.current = true;
        setPayLoading(true);
        try {
            const value = await createEventPageOrder(payload);
            if (value && value.eventPageOrderLink) {
                setTimer(true);
                setPath(`/event-page-order/${value.eventPageOrderLink.gid}/pay`);
            }

        } catch (e) {
            setPayNow(false);
            const errorMsg = e?.response?.data?.message ||e?.data.message || e?.message || "An error occurred";
            setErrorMessage(errorMsg);
            if ( !e?.data?.message) {
                setPath(`/event-page/${eventDetails.gid}/error`);
            }
        } finally {
            setPayLoading(false);
            setTimeout(() => {
                paymentLockRef.current = false;
            }, 500);
        }
    }, [eventDetails?.gid, setPath, expiredToken]);

    const handleNext = () => {
        if (orderItems?.length > 0) {
            const orderItem = orderItems.find((orderItem) => orderItem.productGid === steps[current].productGid);
            if (orderItem?.errors?.length > 0) {
                orderItem.errors.forEach((error) => {
                    notify(error);
                });
                return;
            }
        }

        if ((current + 1 === steps.length - 1
            && orderItems.flatMap(item => item.lineItems).length === 0)) {
            setErrorMessage("Add Items To Proceed...");
        } else if (current < steps.length - 1) {
            if (stockItems.some((stockItem) => stockItem.stockUsed ? stockItem.stockUsed > stockItem.onlineStock : false)) {
                stockItems.filter((stockItem) => stockItem.stockUsed ? stockItem.stockUsed > stockItem.onlineStock : false)
                    .forEach((stockItem) => {
                        notify(<span>Available stock for Item : <strong>{stockItem.displayName}</strong> is : <strong>{stockItem.onlineStock}</strong>, but placed : <strong>{stockItem.stockUsed}</strong></span>);
                    })
                return;
            }
            setCurrent(current + 1);
            setMatchedProduct(eventDetails.eventPageProducts.find((product) => product.gid === (steps[current + 1].productGid)));
            sessionStorage.setItem('placedItems-' + eventDetails.gid.replace('eventpage-', ''), JSON.stringify(orderItems));
        }
    };

    const handleBack = () => {
        if (current > 0) {
            setCurrent(current - 1); // Move backward
            setMatchedProduct(eventDetails.eventPageProducts.find((product) => product.gid === (steps[current - 1].productGid)));
        } else {
            close()
        }
    };

    const handlePayNow = () => {
        setPayload({});
        sessionStorage.setItem('placedItems-' + eventDetails.gid.replace('eventpage-', ''), JSON.stringify(orderItems));
        setPayNow(true);
    };

    useEffect(() => {
        if (payNow && payload.total !== 0) {
            if (Object.keys(payload).length) {
                createOrderAndPay(payload);
            }
        }
    }, [payload, payNow, createOrderAndPay]);

    useEffect(() => {
        if (errorMessage) {
            console.log("Error captured in Products:", errorMessage);
            notify(errorMessage);
            setErrorMessage('');
        }
    }, [errorMessage, notify]);

    useEffect(() => {
        if (orderItems?.length > 0 && stockItems?.length > 0) {
            let updatedStockItems = [...stockItems];
            let mergedLineItems = [];
            orderItems.forEach((orderItem) => {
                if (orderItem.lineItems?.length > 0) {
                    orderItem.lineItems
                        .filter((lineItem) => lineItem.itemGid)
                        .forEach((lineItem) => {
                            const mergedItemIndex = mergedLineItems.findIndex((mergeLineItem) =>
                                mergeLineItem.itemGid === lineItem.itemGid);
                            if (mergedItemIndex === -1) {
                                mergedLineItems.push(lineItem);
                            } else {
                                mergedLineItems = mergedLineItems.map((item, index) =>
                                    index === mergedItemIndex
                                        ? { ...item, quantity: item.quantity + lineItem.quantity }
                                        : item
                                );
                            }
                        }
                        );

                    orderItem.lineItems
                        .filter((lineItem) => lineItem.lineItemItems?.length > 0)
                        .forEach((lineItem) =>
                            lineItem.lineItemItems.forEach((lineItemItem) => {
                                const mergedItemIndex = mergedLineItems.findIndex((mergeLineItem) =>
                                    mergeLineItem.itemGid === lineItemItem.itemGid);
                                if (mergedItemIndex === -1) {
                                    mergedLineItems.push(lineItemItem);
                                } else {
                                    mergedLineItems = mergedLineItems.map((item, index) =>
                                        index === mergedItemIndex
                                            ? { ...item, quantity: item.quantity + (lineItem.quantity * lineItemItem.quantity) }
                                            : item
                                    );
                                }
                            }
                            )
                        );

                }
            });
            mergedLineItems.forEach((lineItem) => {
                const stockIndex = updatedStockItems.findIndex((item) => item.gid === lineItem.itemGid);
                if (stockIndex !== -1) {
                    updatedStockItems[stockIndex] = {
                        ...updatedStockItems[stockIndex],
                        stockUsed: lineItem.quantity
                    };
                }
            });

            updatedStockItems = updatedStockItems.map((stockItem) => ({
                ...stockItem,
                stockUsed: mergedLineItems.some((lineItem) => lineItem.itemGid === stockItem.gid)
                    ? stockItem.stockUsed
                    : 0
            }));

            setStockItems(updatedStockItems);
        }
    }, [orderItems, stockItems]);

    useEffect(() => {
        const checkWrap = () => {
            if (containerRef.current) {
                const children = Array.from(containerRef.current.children);
                if (children.length >= 2) {
                    // Compare first and last item's top positions
                    setIsWrapped(children[0].getBoundingClientRect().top !== children[children.length - 1].getBoundingClientRect().top);
                }
            }
        };

        checkWrap();
        window.addEventListener("resize", checkWrap);
        return () => window.removeEventListener("resize", checkWrap);
    }, [current, orderItems, mobileView]);

    useEffect(() => {
        document.documentElement.style.setProperty("--bottom-length", isWrapped ? "13%" : "11%");
    }, [isWrapped]);

    return (
        <>
            <div className="background">
                {/* Header and Timer integrated into the scrollable content */}

                <div className={`scrollable-content`}>
                    <div style={{ padding: mobileView ? '8px 16px' : '16px 40px', marginBottom: mobileView ? '8px' : '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: '72px', background: '#fff', zIndex: 100, borderBottom: '1px solid #f1f5f9' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <button
                                onClick={handleBack}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '50%',
                                    background: '#fff',
                                    border: '1px solid #e2e8f0',
                                    cursor: 'pointer',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                    transition: 'all 0.2s'
                                }}
                                onMouseOver={(e) => { e.currentTarget.style.background = '#f8fafc'; e.currentTarget.style.borderColor = '#cbd5e1'; }}
                                onMouseOut={(e) => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                            >
                                <img src={backArrow} alt="Back" style={{ width: '20px', height: '20px' }} />
                            </button>
                            <h1 className="select-tickets-heading" style={{ margin: 0, fontSize: mobileView ? '18px' : '24px' }}>
                                {current === steps.length - 1 ? 'Product Details' : 'Select Your Tickets'}
                            </h1>
                        </div>

                        {!fullScreen && expiryTime && (
                            <div className="modern-pill-timer" onClick={() => setShowWarning(true)} style={{ position: 'relative', transform: 'none', top: 'auto', right: 'auto', zIndex: 10, margin: 0 }}>
                                <span className="modern-pill-timer-label" style={{ fontSize: mobileView ? '9px' : '11px' }}>Time Left</span>
                                <span className="modern-pill-timer-time" style={{ fontSize: mobileView ? '16px' : '26px', minWidth: mobileView ? '50px' : '85px' }}>{formatTime(count)}</span>
                                <div className="modern-pill-timer-icon" style={{ width: mobileView ? '20px' : '28px', height: mobileView ? '20px' : '28px' }}>
                                    <div className="modern-pill-timer-dot" style={{ transformOrigin: mobileView ? 'center 6px' : 'center 8px' }}></div>
                                </div>
                            </div>
                        )}
                    </div>

                    {current === steps.length - 1 ?
                        <ProductReview
                            eventDetails={eventDetails}
                            orderItems={orderItems}
                            setOrderItems={setOrderItems}
                            setPayload={setPayload}
                            setPayNow={setPayNow}
                            payNow={payNow}
                            setErrorMessage={setErrorMessage}
                            getOperatingTime={getOperatingTime}
                            mobileView={mobileView}
                            handleBack={handleBack}
                            hideHeader={true}
                            selectedDate={selectedDate}
                            setSelectedDate={setSelectedDate}
                        />
                        : <AddProducts
                            eventDetails={eventDetails}
                            eventPageProduct={matchedProduct}
                            orderItemIndex={current}
                            lineItems={orderItems[current] ? orderItems[current].lineItems : []}
                            setOrderItems={setOrderItems}
                            getOperatingTime={getOperatingTime}
                            expiredToken={expiredToken}
                            notify={notify}
                            setShowButton={setShowButton}
                            setFullScreen={setFullScreen}
                            mobileView={mobileView}
                            handleNext={handleNext}
                            selectedDate={selectedDate}
                            setSelectedDate={setSelectedDate}
                        />
                    }
                </div>

                {!fullScreen && (
                    <>
                        {/* Fixed Footer */}
                        {showButton && (
                            <div className="fixed-footer">
                            {showButton && current < steps.length - 1 && eventDetails?.isSeatedEvent && (
                                <div className="d-flex align-items-center justify-content-between" style={{ width: '100%', padding: mobileView ? '0 8%' : '0 16%' }}>
                                    <div ref={containerRef} className="d-flex align-items-center gap-8"
                                        style={{
                                            color: '#fff',
                                            marginRight: '10px',
                                            display: 'flex',
                                            flexWrap: mobileView ? 'wrap' : 'nowrap',
                                        }}>
                                        {orderItems.map((orderItem, index) => {
                                            if (index > current) return null;

                                            return (
                                                <React.Fragment key={index}>
                                                    <div style={{ fontSize: mobileView ? '16px' : '22px', fontWeight: 'bold' }}>
                                                        ${parseFloat((orderItem.totalAmount ? orderItem.totalAmount : 0) / 100)
                                                            .toFixed(2)
                                                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                                                        <div style={{ fontSize: mobileView ? '8px' : '10px' }}>
                                                            {orderItem.totalCount} {orderItem.title}{orderItem.totalCount > 1 ? 's' : ''}
                                                        </div>
                                                    </div>

                                                    {/* Add "+" separator between items, but not after the last one */}
                                                    {index !== current && <div style={{ fontSize: mobileView ? '14px' : '22px', padding: mobileView ? '1.5px' : '3px' }}>+</div>}
                                                </React.Fragment>
                                            );
                                        })}
                                    </div>

                                    <button
                                        className="book-now-btn product-bottom-button"
                                        style={{ background: '#000' }}
                                        disabled={(orderItems[0]?.totalAmount || 0) === 0}
                                        onClick={handleNext}
                                    >
                                        Next
                                    </button>
                                </div>
                            )}
                            {showButton && (current === steps.length - 1) && (
                                <button
                                    className="book-now-btn"
                                    style={{ background: eventDetails?.primaryColor || '#2563eb' }}
                                    disabled={(current + 1 === steps.length - 1 && orderItems.flatMap(item => item.lineItems).length === 0) && payNow}
                                    onClick={handlePayNow}
                                >
                                    Pay Now
                                </button>
                            )}
                            </div>
                        )}
                    </>
                )}

                <SoldOutModal body={
                    <>
                        Sorry! We are sold out for event:{" "}
                        {eventDetails && <span style={{ fontWeight: "bold" }}>{eventDetails.title}</span>}
                    </>
                } icon={sorry} isOpen={eventDetails && eventDetails.status === 'SOLD_OUT'} />
                <SoldOutModal body={
                    <>
                        Sorry! {eventDetails && <span style={{ fontWeight: "bold" }}>{eventDetails.title}</span>} is Closed.
                    </>
                } icon={sorry} isOpen={eventDetails && eventDetails.status === 'DEACTIVATED'} />
                <SoldOutModal body={
                    <>
                        <div
                            className="d-flex align-items-center justify-content-center"
                            style={{
                                flexDirection: 'column',
                                textAlign: 'center',
                                padding: '20px'
                            }}>
                            {/* Loader */}
                            <div className='spinner-border loader' />

                            {/* Loading Message */}
                            <div className="loader-message">
                                Your order is being processed... <br />
                                Please wait and avoid closing or reloading this page. <br />
                                Thank you for your patience!
                            </div>
                        </div>
                    </>
                } isOpen={payLoading} />
            </div>
        </>
    )
};

export default GoogleApiWrapper({
    apiKey: 'AIzaSyCLR2kMaQ9AHIa_tqsG48hxA9CZ7ullXds'
})(Products);
